import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

type TemplatesMarketplaceEmptyProps = {
  hasNoResults?: boolean;
};

const TemplatesMarketplaceEmpty = ({ hasNoResults }: TemplatesMarketplaceEmptyProps) => {
  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState
          title="No templates available yet"
          icon={EmptystateCodeBrowserColored}
          caption="Templates are ready-to-use infrastructure configurations. When your platform team publishes templates, you'll see them here."
        >
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/concepts/template/deployments")}
              label="Learn more"
            />
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default TemplatesMarketplaceEmpty;
